import React, { useState } from 'react'
import styled from 'styled-components'
import chevron from '../images/chevron-forward.png'

const Wrapper = styled.div`
    margin-top: 32px;
    margin-bottom: 16px;
`

const Row = styled.div`
    border-bottom: 0.5px solid #E4E7E7;
    padding: 16px 0;
`
const Header = styled.h2`
    font-size: 16px;
    margin: 0;
    font-weight: 400;
    display: flex;
    align-items: center;
    position: relative;

    img {
        width: 32px;
        height: 24px;
        margin-right: 16px;
    }

    &::after {
        content: "";
        width: 16px;
        height: 16px;
        background: url(${chevron});
        position: absolute;
        right: 0;
        background-size: contain;
        transform: rotate(${(props) => props.active ? "90deg" : "0deg"});
        transition: transform 300ms;
    }
`

const Body = styled.p`
    font-size: 14px;
    color: #7A8585;
    padding-left: 48px;
    margin: 8px 0 0 0;
    display: ${(props) => props.active ? 'block' : 'none'};
`

const Accordion = ({ data }) => {
    const [ currentActive, setCurrentActive ] = useState(0)

    const toggleState = (state) => {
        if (state === currentActive) {
            setCurrentActive(0)
        } else {
            setCurrentActive(state)
        }
    }
    return (
        <Wrapper>
            {data.map((row, index) => (
                <Row key={row.title} active={currentActive === (index + 1)} onClick={() => toggleState(index + 1)}>
                    <Header active={currentActive === (index + 1)}><img src={row.icon} alt={row.title} /> {row.title}</Header>
                    <Body active={currentActive === (index + 1)}>{row.text}</Body>
                </Row>
            ))}
        </Wrapper>
    )
}

export default Accordion